import { SMSHistoryQueryOrderDTO } from "./sms-history-query-order.dto";

export class SMSHistorySearchPaginatedDTO {
  offset?: number;
  limit?: number;
  term?: string;
  order?: SMSHistoryQueryOrderDTO;
}
